export const baseStyle = {
  width: 130,
  borderStyle: "solid",
  borderWidth: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 800,
  borderColor: "var(--goa-color-brand-default, #0081a2)",
};